  import React, { Component } from "react";
import Slider from "react-slick";
import Img1 from '../img/Untitled-1 1.jpg';
import Img2 from '../img/Nellie-Helicopter 1.jpg';
import Img3 from '../img/Christabel-SkywireatNelsonbay 1.jpg';
import Img4 from '../img/Christabel-Skydiving 1.jpg';
import Img5 from '../img/Nellie-BrassPeak 1.jpg';
import Img6 from '../img/Christabel-Waka-Abel-Tasman 1.jpg';
import Img7 from '../img/Nellie-TwizelSalmonFarm 1.jpg';
import NextArrow from '../img/Arrow Right.png';
import PrevArrow from '../img/Arrow Left.png'

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block"}}
      onClick={onClick}><img className="arrow" src={NextArrow}/></div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}><img className="arrow" src={PrevArrow}/></div>
  );
}

export default class SimpleSlider extends Component {
  render() {
    const settings = {
        infinite: true,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        variableWidth: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          },
      ]
    };
    return (
      <div>
        <Slider {...settings} className="getinspired-carousel">
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img1}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@therideside<br/></p>
                    <p className="small-text">Affectionally known as "Cardies”, Cardrona has something for everyone. Experience some of the best jumps and facilities which suit both first time skiers & and advances riders alike!</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img2}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@nellielim<br/></p>
                    <p className="small-text">We chartered a scenic private helicopter ride with Mount Cook Ski Planes & Helicopters and it was the most magical experience of our entire New Zealand trip.</p>
                </div>   
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img3}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@bellywellyjelly<br/></p>
                    <p className="small-text">The view from the world's longest flying fox is one of the most amazing feelings you'll ever get. Flying high above the forest canopy, you feel like you're on top of the world!</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img4}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@bellywellyjelly<br/></p>
                    <p className="small-text">This is the #1 activity you need to tick off your list when visiting NZ. - Sky Diving! The wind speed gliding against your skin so fast that your face makes the ugliest of expressions while you struggle to fathom the amazing world we live in.</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img5}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@nellylim<br/></p>
                    <p className="small-text">An unforgettable memory on top of Brass Peak with the surprise proposal that my husband planned. This spot is definitely one of the most romantic places you can declare your undying love for your partner.</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img6}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@bellywellyjelly<br/></p>
                    <p className="small-text">One of the best things you can do for your mental health is to wake up bright and early, have gentle sun rays shining into your eyes while listening to the waves crash against the shore. This is exactly what you will be greeted with as you embark on your journey with Waka Abel Tasman.</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={Img7}/>
                </div>
                <div className="content pt-3 pb-5">
                    <p className="serif-bold mb-1">@nellielim<br/></p>
                    <p className="small-text">I’m a huge fan of salmon so I always make it a point to get brunch at Twizel Salmon Farm. Fresh sashimi, sushi and even smoked salmon bagels await you. You can even try your hand at fishing for some salmon.</p>
                </div>  
            </div> 
          </Slider>
      </div>
    );
  }
}